/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightManager, SpotlightPulse, SpotlightTarget } from '@atlaskit/onboarding';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, Grid, xcss } from '@atlaskit/primitives';

import { MoreIconPopup } from '../feedback-popup-menu';

import { type FeedbackFormSectionProps } from './types';

const feedbackSectionStyles = xcss({
	backgroundColor: 'color.background.information',
	position: 'relative',
	height: 'space.800',
});

export const FeedbackFormSectionLayout = ({ showForm, components }: FeedbackFormSectionProps): JSX.Element | null => {
	const { form } = components;

	// if comparison feedback is submitted, hide this entire section
	if (!showForm) {
		return null;
	}

	return (
		<SpotlightManager>
			<SpotlightTarget name="new">
				<SpotlightPulse radius={3} pulse>
					<Grid xcss={feedbackSectionStyles} templateColumns="1fr 42px">
						<Flex justifyContent={'center'}>{showForm && form}</Flex>
						<MoreIconPopup />
					</Grid>
				</SpotlightPulse>
			</SpotlightTarget>
		</SpotlightManager>
	);
};
